<template>
  <div>
    <div class="layer_box">
      <div class="mian-box">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="修改独立密码" name="first">
            <Brotherone />
          </el-tab-pane>
          <el-tab-pane label="撤销独立密码" name="second">
            <BrotherTwo />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Brotherone from "./BrotherOne.vue";
import BrotherTwo from "./BrotherTwo.vue";
export default {
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    Brotherone,
    BrotherTwo,
  },
  props: ["cutcoms"],
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.layer_box {
  height: 100%;
  background: #FFFFFF;
opacity: 1;
border-radius: 0  0 10px 10px;
}
.el-tabs{
    margin-top: 50px;
}
.mian-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ::v-deep .el-tabs__nav {
    display: flex;
    border: 1px solid #1890ff;
  }
  ::v-deep .el-tabs__item {
    width: 180px;
    height: 50px;
    line-height: 50px;
    //   padding: 0 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    //    border-bottom-color: #1890FF;
    border: 1px solid #1890ff;
    background: #1890ff;
    color: #ffffff;
  }
  ::v-deep .el-tabs--card>.el-tabs__header{
      border: none;
      display: flex;
      justify-content: center;
      width: 100%;
  }
    
}
</style>